var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"cellInstancesHolder",staticStyle:{"display":"none"}},_vm._l((_vm.cellInstances),function(component){return _c(component.is,_vm._b({key:component.key,ref:component.key,refInFor:true,tag:"component"},'component',component,false))}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }